import React from "react";
import Mid from "./Body/Mid";
import BottomDiv from "./Body/BottomDiv";

export default function BodyPart() {
  return (
    <>
      <Mid></Mid>
      <BottomDiv></BottomDiv>
    </>
  );
}
